import { InputField } from "@risalabs_frontend_org/oasis-ui-kit";

/** Props for manual primary Dx code entry fields. */
export interface ManualDxEntryFieldsProps {
  manualPrimaryCode: string;
  description: string;
  isManualEntryMissing: boolean;
  onManualCodeChange: (value: string) => void;
}

/**
 * Manual primary Dx code and description inputs shown when Enter Manually
 * is selected.
 *
 * @param props - Manual entry values and change handler.
 */
export const ManualDxEntryFields = ({
  manualPrimaryCode,
  description,
  isManualEntryMissing,
  onManualCodeChange,
}: ManualDxEntryFieldsProps) => (
  <div className="primaryDx-enter-manual-input-container flex w-full gap-2">
    <InputField
      id="primaryDxManual"
      label="Primary Dx Code"
      placeholder="Enter the DX Code"
      value={manualPrimaryCode}
      onChange={(e) => onManualCodeChange(e.target.value)}
      size="md"
      className="w-[30%]"
      required
      error={isManualEntryMissing ? "Primary Dx Code is required" : ""}
    />
    <InputField
      id="primaryDxManualDescription"
      label="Dx Code Description"
      placeholder="Description of the DX Code"
      readOnly={true}
      value={description}
      size="md"
      className="w-[70%]"
    />
  </div>
);
